import React from "react";
import { Button } from "@material-ui/core";
import { useStateValue } from "./../providers/StateProvider";
import { actionTypes } from "../utils/reducer";
import { auth, provider } from "../firebase";
import Google from "../images/google.png";
import "../css/Login.css";

function Login() {
  const [{}, dispatch] = useStateValue();

  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user,
        });
      })
      .catch((e) => console.log(e.message));
  };

  return (
    <div className="login">
      <div className="login__container">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Slack_Technologies_Logo.svg/1280px-Slack_Technologies_Logo.svg.png"
          alt="Where Work Happens | Slack"
        />

        <h1>Sign in to Global Slack Tech</h1>

        <p>
          Slack is a new way to communicate with your team. It’s faster,
          <br /> better organized, and more secure than email.
        </p>

        <Button onClick={signIn} variant="contained">
          <img src={Google} alt="Google" /> Sign In with Google
        </Button>
      </div>
    </div>
  );
}

export default Login;
